import { minBy, maxBy } from 'lodash'
import { logLengthSorter } from '@/components/account/account-scaling/log-lengths/LogLengths.js'
import store from '@/store/index.js'
import { localeCompareAlphanumeric } from '@/utils/base'

export function lengthGroupSorter (lengthGroupA, lengthGroupB) {
  const useLogLengths = lengthGroupA?.logLengths && lengthGroupB?.logLengths
  let result
  if (useLogLengths) {
    result = getMinLength(lengthGroupA) - getMinLength(lengthGroupB)
    if (result === 0) {
      result = getMaxLength(lengthGroupA) - getMaxLength(lengthGroupB)
    }
  }
  if (result === 0 || !useLogLengths) {
    result = localeCompareAlphanumeric(lengthGroupA?.label ?? '', lengthGroupB?.label ?? '')
  }
  return result
}

export function lengthGroupSorterByLabel (lengthGroupLabelA, lengthGroupLabelB) {
  const lgA = store.getters['account-scaling/accountLengthGroups']
    .find(lg => lg.label === lengthGroupLabelA)
  const lgB = store.getters['account-scaling/accountLengthGroups']
    .find(lg => lg.label === lengthGroupLabelB)
  if (!lgA || !lgB) return localeCompareAlphanumeric(lengthGroupLabelA ?? '', lengthGroupLabelB ?? '')
  return lengthGroupSorter(lgA, lgB)
}

function getMinLength (lengthGroup) {
  if (!lengthGroup?.logLengths) return undefined
  return minBy(
    lengthGroup.logLengths,
    lengthFromLengthObject).length
}

function getMaxLength (lengthGroup) {
  if (!lengthGroup?.logLengths) return undefined
  return maxBy(
    lengthGroup.logLengths,
    lengthFromLengthObject).length
}

function lengthFromLengthObject (lengthObject) { return lengthObject.length }

export function sortLengthsWithinGroups (lengthGroups) {
  if (!lengthGroups) return
  lengthGroups.forEach(lengthGroup =>
    lengthGroup.logLengths?.sort(logLengthSorter)
  )
}

export function getLengthGroupTooltip (rateSheetLine, accountId, lengthGroups) {
  function matchesById (lg) {
    return lg.lengthGroupId === (rateSheetLine.lengthGroupId ?? rateSheetLine.lengthGroup?.lengthGroupId)
  }
  function matchesByLabel (lg) {
    return lg.label === rateSheetLine.lengthGroup
  }

  if (!lengthGroups && accountId !== store.getters['account-scaling/accountIdOfLengthGroups']) return undefined
  const lengthGroup = (lengthGroups ?? store.getters['account-scaling/accountLengthGroups'])
    .find(lg => matchesById(lg) || matchesByLabel(lg))
  if (!lengthGroup) return undefined
  return lengthGroup.logLengths.map(l => `${l.length}'`).join(', ')
}
